module.exports = __webpack_public_path__ + "img/heatmap_example.26961dfb.png";